import {
    createReportBlogArticleClicked,
    createReportFAQClicked,
    createReportGetStartedSubmitted,
} from '../../../../shared/mixpanel/events';
import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_PAGE_NAMES } from '../../../../shared/mixpanel';
import store from '../store';
import { reportPageView } from './reportPageView';

const enrichment = {
    [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.INTEGRATION_LANDING_PAGE,
} as const;

const reportBlogArticleClicked = createReportBlogArticleClicked(store, enrichment);
const reportFAQClicked = createReportFAQClicked(store, enrichment);
const reportGetStartedSubmitted = createReportGetStartedSubmitted(store, enrichment);

export { reportPageView, reportBlogArticleClicked, reportFAQClicked, reportGetStartedSubmitted };
